export default __webpack_public_path__ + "static/media/section-2.57e29921.jpg";